
import * as angular from "angular";
import "./account/account.module";
import "./companyImage/companyImage.module";
import "./components.scss";
import "./csvImporter/csvImporter.module";
import "./diagnostics/diagnostics.module.ajs";
import "./drivers/drivers.module";
import "./fleetMaintenance/fleetMaintenance.module";
import "./insights/insights.module.ajs";
import "./livemap/livemap.module.ajs";
import "./mobile/mobile.module";
import "./nps/nps.module.ajs";
import "./planning/planning.module";
import "./planning/tms.module";
import "./reports/dynamicreports.module.ajs";
import "./resourceManagement/geofences/geofences.module";
import "./tacho/_tacho.module.ajs";
import "./util/util.module";
import "./videos/_videos.module.ajs";

angular
    .module("app.components", [
        "app.components.util.api",
        "app.components.livemap",
        "app.components.mobile",

        "app.components.drivers",
        "app.components.videos",
        "app.components.util",

        "app.components.nps",

        "app.components.messaging",
        "app.components.planning",
        "app.components.tms",
        "app.components.tacho",
        "app.components.geofences",
        "app.components.dynamicreports",
        "app.components.insights",
        "app.components.account",
        "app.components.companyImage",
        "app.components.fleetMaintenance",
        "app.components.csvImporter",
        "app.components.diagnostics"
    ]);
